const e = "Account", o = "Saldo del conto", i = "Descrizione conto", a = "ID conto", t = "Aggiunte", n = "Aggiustamenti", r = "Importo", s = "e", c = "Applica", l = "Indietro", d = "Saldo del conto", u = "ID saldo del conto", p = "Prenotato", m = "Acquisito", f = "Categoria", g = "Chargeback", b = "Chiudi", v = "Contatta il supporto", h = "Contatta il supporto per assistenza.", y = "Contatta l'assistenza per un aiuto e condividi il codice di errore %{requestId}", z = "Copiato", T = "Copia", R = "Correzioni", C = "Valuta", A = "Data", P = "Intervallo di date", N = "Descrizione", I = "Ignora", S = "Scarica", F = "Download in corso", D = "E-mail", O = "L'entità non è stata trovata", q = "Transazione non trovata per il titolare del conto specificato", x = "Commissioni", L = "File", w = "Barra dei filtri", W = "Da", k = "Completo", B = "Fondi acquisiti", M = "Torna indietro", E = "Sovvenzione rilasciata", V = "Rimborsi delle sovvenzioni", U = "Nascondi contenuto", H = "Numero identificativo", Y = "Campo incompleto", Q = "In corso", _ = "Caricamento in corso", G = "max", X = "min", j = "Mobile", J = "Pagamento netto", K = "Prossimi pagamenti", Z = "Nessun dato", $ = "Non sono ammessi numeri negativi", ee = "Nessun pagamento trovato", oe = "Nessun report trovato", ie = "Nessuna transazione trovata", ae = "Altro", te = "Navigazione a pagine", ne = "Parziale", re = "ID di pagamento", se = "Metodo di pagamento", ce = "Dettagli di pagamento", le = "Le informazioni sui pagamenti vengono generate ogni giorno a mezzanotte, ora UTC.", de = "Pagamenti", ue = "In sospeso", pe = "Torna più tardi.", me = "Contatta il supporto per ricevere assistenza.", fe = "Contatta il supporto", ge = "ID di riferimento", be = "Aggiorna", ve = "Rimborsi", he = "Rimborsa pagamento", ye = "L'elaborazione del rimborso non è riuscita. Riprova più tardi.", ze = "Si è verificato un errore.", Te = "Il cliente riceverà il denaro entro un massimo di 40 giorni. Se il rimborso andrà a buon fine, nell'elenco verrà visualizzata una nuova transazione relativa al rimborso.", Re = "Il rimborso è stato inviato.", Ce = "Importo da rimborsare", Ae = "Il rimborso può richiedere fino a 40 giorni a seconda del metodo di pagamento. Le spese sono incluse.", Pe = "Rimborso %{amount}", Ne = "Motivo del rimborso", Ie = "Riferimento", Se = "Importo rimanente", Fe = "Report", De = "I report vengono generati ogni giorno a mezzanotte, ora UTC.", Oe = "Report", qe = "Reimposta", xe = "Revocato", Le = "Si è verificato un errore.", we = "Qualcosa è andato storto. Prova ad aggiornare la pagina o torna più tardi.", We = "Stato", ke = "Elenco strutturato", Be = "Sottrazioni", Me = "Somma dei pagamenti dello stesso giorno", Ee = "Schede", Ve = "Il codice di errore è %{requestId}", Ue = "Nessun risultato", He = "Nella richiesta mancano i campi obbligatori o contiene dati non validi.", Ye = "Si è verificato un errore imprevisto", Qe = "Il saldo del conto selezionato non è corretto", _e = "Fuso orario", Ge = "A", Xe = "Entrate totali", je = "Totale uscite", Je = "Il valore A deve essere uguale o maggiore del valore Da", Ke = "Dettagli della transazione", Ze = "Transazioni", $e = "Panoramica delle transazioni", eo = "Tipo di transazione", oo = "Trasferimenti", io = "Prova a effettuare una ricerca diversa o a reimpostare i filtri e ritenteremo.", ao = "Prova ad aggiornare la pagina o torna più tardi.", to = "Importo", no = "Tipo", ro = "Valore", so = "Non è stato possibile caricare la panoramica dei pagamenti.", co = "Non è stato possibile caricare la panoramica dei report.", lo = "Non è stato possibile caricare la panoramica delle transazioni.", uo = "Non è stato possibile caricare il saldo dei tuoi conti.", po = "Non è stato possibile caricare i tuoi pagamenti.", mo = "Non è stato possibile caricare i tuoi report.", fo = "Non è stato possibile caricare le tue transazioni.", go = {
  account: e,
  accountBalance: o,
  accountDescription: i,
  accountID: a,
  additions: t,
  adjustments: n,
  amount: r,
  and: s,
  apply: c,
  back: l,
  balanceAccount: d,
  balanceAccountId: u,
  Booked: p,
  "button.clearAll": "Svuota tutto",
  "calendar.controls": "Controlli di navigazione del calendario",
  "calendar.nextMonth": "Prossimo mese",
  "calendar.previousMonth": "Mese precedente",
  "calendar.timezone": "Il fuso orario è impostato su: GMT%{offset} (%{time})",
  "capital.accountIsInactive": "Il tuo conto è inattivo",
  "capital.actionNeeded": "Azione necessaria",
  "capital.bankAccountDetails": "Dati del conto bancario",
  "capital.bankAccountIban": "IBAN",
  "capital.bankAccountNumber": "Numero di conto",
  "capital.bankCountryOrRegion": "Paese/Area geografica",
  "capital.bankRoutingNumber": "Numero d'instradamento",
  "capital.bankSortCode": "Codice di avviamento",
  "capital.businessFinancing": "Finanziamento aziendale",
  "capital.businessFinancingOffer": "Offerta di finanziamento aziendale",
  "capital.businessFinancingSummary": "Riepilogo del finanziamento aziendale",
  "capital.closed": "Chiuso",
  "capital.couldNotContinueWithTheOffer": "Non siamo riusciti a continuare con l'offerta.",
  "capital.couldNotLoadFinancialOffers": "Non siamo riusciti a caricare le offerte finanziarie.",
  "capital.dailyRepaymentRate": "Tasso di rimborso giornaliero",
  "capital.daysAndDaysLeft": "%{days} giorni (%{daysLeft} giorni rimanenti)",
  "capital.expectedRepaymentPeriod": "Periodo di rimborso previsto",
  "capital.failed": "Non riuscito",
  "capital.fees": "Commissioni",
  "capital.fullyRepaid": "Interamente rimborsato",
  "capital.goToTermsAndConditions": "Vai a Termini e condizioni",
  "capital.grantID": "ID della sovvenzione",
  "capital.howMuchMoneyDoYouNeed": "Di quanto denaro hai bisogno?",
  "capital.inProgress": "In corso",
  "capital.legalSubtitleAU": "Adyen Capital è fornito da Adyen Australia Pty Limited.",
  "capital.legalSubtitleEU": "I prestiti sono emessi da Adyen N.V.",
  "capital.legalSubtitleGB": "I prestiti sono emessi da Adyen N.V. rappresentata dalla sua filiale di Londra.",
  "capital.legalSubtitleUS": "I prestiti sono emessi dalla filiale di San Francisco di Adyen N.V. e sono soggetti all'approvazione del credito.",
  "capital.maximumRepaymentPeriod": "Periodo massimo di rimborso",
  "capital.minimumRepaymentToRepayTheFinancingOnTime": "Rimborso minimo ogni %{days} giorni per rimborsare il finanziamento in tempo",
  "capital.needSomeExtraMoney": "Hai bisogno di soldi extra?",
  "capital.offerLegalNoticeDescriptionUS": "Se la tua richiesta di credito aziendale viene respinta, hai il diritto di ricevere una dichiarazione scritta contenente i motivi specifici del rifiuto. Per riceverla, contatta il team di assistenza al credito di Adyen via e-mail all'indirizzo %{email} entro 60 giorni dalla data in cui hai ricevuto comunicazione della nostra decisione. Ti invieremo una dichiarazione scritta entro 30 giorni dal ricevimento della tua richiesta. %{break} La legge federale Equal Credit Opportunity Act (Parità di opportunità nel credito) vieta ai creditori di discriminare i richiedenti sulla base di razza, colore, religione, origine nazionale, sesso, stato civile, età (a condizione che il richiedente abbia la capacità giuridica di stipulare un contratto giuridicamente vincolante), qualora la totalità o parte del loro reddito provenga da programmi di assistenza pubblica o perché abbiano esercitato in buona fede qualsiasi diritto ai sensi del Consumer Credit Protection Act (Legge a tutela del credito dei consumatori). L'agenzia federale che si occupa del rispetto di questa legge in relazione a questo creditore è l'Office of the Comptroller of the Currency (OCC), 400 7th Street, SW Washington, DC 20219.",
  "capital.offerLegalNoticeTitleUS": "Creditore: Adyen N.V. – Filiale di San Francisco %{break} 505 Brannan Street, San Francisco, CA 94107.",
  "capital.oneMonth": "1 mese",
  "capital.pending": "In sospeso",
  "capital.primaryAccount": "Conto principale",
  "capital.remaining": "Restante",
  "capital.remainingAmount": "Importo rimanente",
  "capital.remainingFees": "Commissioni rimanenti",
  "capital.repaid": "Rimborsato",
  "capital.repaidAmount": "Importo rimborsato",
  "capital.repaidFees": "Commissioni rimborsate",
  "capital.repaymentBalanceInfo": "L'importo rimanente attuale, comprese le commissioni, è di %{amount}",
  "capital.repaymentThreshold": "Soglia di rimborso",
  "capital.requestedFunds": "Fondi richiesti",
  "capital.requestFunds": "Richiesta di fondi",
  "capital.requesting": "Richiesta",
  "capital.reviewOffer": "Rivedi l'offerta",
  "capital.revoked": "Revocata",
  "capital.seeNewOffer": "Vedi la nuova offerta",
  "capital.seeOptions": "Visualizza opzioni",
  "capital.sendRepayment": "Invia rimborso",
  "capital.sendRepaymentNotice": "Il bonifico bancario addizionale per il rimborso del prestito potrebbe richiedere 2-3 giorni lavorativi prima di risultare correttamente.",
  "capital.sendRepaymentSubtitle": "Effettua un trasferimento di denaro su questo conto bancario per rimborsare parzialmente o interamente il tuo prestito.",
  "capital.signTermsAndConditionsToReceiveFunds": "Firma i Termini e le condizioni per ricevere i tuoi fondi.",
  "capital.signTheTermsToReceiveYourFunds": "Firma i termini per ricevere i tuoi fondi",
  "capital.termEnds": "Termine ultimo: ",
  "capital.thereIsNoPrimaryAccountConfigured": "Non hai configurato alcun conto principale",
  "capital.thisOfferExpiresOn": "Questa offerta scade il %{date}.",
  "capital.totalFees": "Totale commissioni",
  "capital.totalRepaymentAmount": "Importo totale del rimborso",
  "capital.unsupportedRegionDescription": "Il finanziamento alle imprese non è ancora disponibile nella tua regione, ma torna a trovarci per ricevere un'offerta.",
  "capital.unsupportedRegionTitle": "Continua a seguirci.",
  "capital.weCouldNotContinueWithTheOffer": "Non siamo riusciti a continuare con l'offerta.",
  "capital.weCouldNotContinueWithTheOfferContactSupportForHelp": "Non siamo riusciti a continuare con l'offerta. Contatta il supporto per assistenza.",
  "capital.weCouldNotLoadFinancialOffers": "Non siamo riusciti a caricare le offerte finanziarie.",
  "capital.weCouldNotProcessThisRequestTryAgain": "Non è stato possibile elaborare questa richiesta. Riprova con una nuova offerta.",
  "capital.weReceivedYourRequestAndWeAreWorkingOnItNowCheckBackSoon": "Abbiamo ricevuto la tua richiesta e ci stiamo lavorando. Presto riceverai una notifica per i prossimi passaggi.",
  "capital.writtenOff": "Scartato",
  "capital.xDays": "%{days} giorni",
  "capital.xMonths": "%{months} mesi",
  "capital.xPercent": "%{percentage}%",
  "capital.youAcceptedButThenReturnedTheseFunds": "Hai accettato ma poi hai restituito questi fondi",
  "capital.youAcceptedTheseFundsButDidNotRepayThem": "Hai accettato questi fondi ma non li hai restituiti",
  "capital.youAreRequestingFundingOf": "Stai richiedendo il finanziamento di",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part1": "Hai ottenuto una prequalificazione per un finanziamento aziendale",
  "capital.youHaveBeenPrequalifiedForBusinessFinancingUpToX.part2": " fino a %{amount}.",
  "capital.yourRequestedFundsWere": "I fondi richiesti erano: ",
  "capital.youShouldGetTheFundsWithinOneBusinessDay": "Dovresti ricevere i fondi entro un giorno lavorativo",
  "capital.youWillNeedToRepayAMinimumOfXEveryXDaysToPayOffTheFunds": "Dovrai rimborsare un minimo di %{amount} ogni %{days} giorni per ripagare completamente i fondi entro il %{date}.",
  "capital.youWillSoonQualifyForAFinancialOffer": "Presto riceverai un'offerta finanziaria!",
  capture: m,
  category: f,
  chargeback: g,
  closeIconLabel: b,
  contactSupport: v,
  contactSupportForHelp: h,
  contactSupportForHelpAndShareErrorCode: y,
  copied: z,
  copy: T,
  correction: R,
  currency: C,
  date: A,
  dateRange: P,
  default: "Default",
  description: N,
  dismiss: I,
  download: S,
  downloading: F,
  email: D,
  entityWasNotFound: O,
  entityWasNotFoundDetail: q,
  "error.pleaseTryAgainLater": "Riprova più tardi.",
  "error.somethingWentWrongWithDownload": "Si è verificato un problema durante il download",
  "expandableCard.collapse": "Comprimi",
  "expandableCard.expand": "Espandi",
  export: "Esporta",
  fee: x,
  file: L,
  "filter.date.since": "Dal %{date}",
  "filter.date.until": "Fino a %{date}",
  filterBar: w,
  "filterPlaceholder.category": "Tipo",
  "filterPlaceholder.currency": "Valuta",
  "filterPlaceholder.status": "Stato",
  from: W,
  full: k,
  fundsCaptured: B,
  goBack: M,
  grantIssued: E,
  grantRepayment: V,
  hideContent: U,
  id: H,
  incompleteField: Y,
  inProgress: Q,
  loading: _,
  max: G,
  min: X,
  mobile: j,
  netPayout: J,
  nextPayouts: K,
  noData: Z,
  noNegativeNumbersAllowed: $,
  noPayoutsFound: ee,
  noReportsFound: oe,
  noTransactionsFound: ie,
  other: ae,
  paginatedNavigation: te,
  "pagination.nextPage": "Pagina successiva",
  "pagination.previousPage": "Pagina precedente",
  "pagination.showing": "Risultati:",
  partial: ne,
  paymentId: re,
  paymentMethod: se,
  payoutDetails: ce,
  payoutsNotice: le,
  payoutsTitle: de,
  Pending: ue,
  pleaseComeBackLater: pe,
  pleaseReachOutToSupportForAssistance: me,
  "rangePreset.custom": "Personalizzato",
  "rangePreset.last30Days": "Ultimi 30 giorni",
  "rangePreset.last7Days": "Ultimi 7 giorni",
  "rangePreset.lastMonth": "Il mese scorso",
  "rangePreset.lastWeek": "La scorsa settimana",
  "rangePreset.thisMonth": "Questo mese",
  "rangePreset.thisWeek": "Questa settimana",
  "rangePreset.yearToDate": "Da inizio anno",
  reachOutToSupport: fe,
  referenceID: ge,
  refresh: be,
  refund: ve,
  "refund.amountAlreadyRefunded": "Hai già rimborsato %{amount}",
  "refund.amountFailed": "Il rimborso di %{amount} non è andato a buon fine. Non è attualmente possibile rimborsare questo importo. Contatta l'assistenza.",
  "refund.amountInProgress": "Il rimborso parziale di %{amount} è in elaborazione.",
  "refund.fee": "Commissione",
  "refund.fullAmountFailed": "Non è possibile rimborsare questo pagamento. Contatta l'assistenza.",
  "refund.fullAmountRefunded": "L'importo totale è stato rimborsato al cliente",
  "refund.goToPayment": "Vai al pagamento",
  "refund.maximumRefundable": "Puoi rimborsare solo un massimo di %{amount}",
  "refund.onlyRefundable": "Puoi rimborsare solo %{amount}",
  "refund.originalAmount": "Importo originale",
  "refund.originalPayment": "Pagamento originale",
  "refund.paymentPspReference": "Riferimento PSP del pagamento",
  "refund.pspReference": "Riferimento PSP",
  "refund.refundFee": "Spese di rimborso",
  "refund.refundPspReference": "Riferimento PSP per il rimborso",
  "refund.returnToRefund": "Torna al rimborso",
  "refund.theRefundIsBeingProcessed": "Il rimborso è in fase di elaborazione.",
  refundAction: he,
  refundActionErrorSubtitle: ye,
  refundActionErrorTitle: ze,
  refundActionSuccessSubtitle: Te,
  refundActionSuccessTitle: Re,
  refundAmount: Ce,
  "refundAmount.excess": "Non puoi superare l'importo disponibile di %{amount}",
  "refundAmount.required": "Inserisci un importo da rimborsare",
  "refunded.full": "Interamente rimborsato",
  "refunded.partial": "Parzialmente rimborsato",
  refundNotice: Ae,
  refundPayment: Pe,
  refundReason: Ne,
  "refundReason.duplicate": "Duplicato",
  "refundReason.fraudulent": "Fraudolento",
  "refundReason.issue_with_item_sold": "Problema con l'articolo venduto",
  "refundReason.other": "Altro",
  "refundReason.requested_by_customer": "Richiesto dal cliente",
  refundReference: Ie,
  "refundReference.placeholder": "Inserisci qui il riferimento",
  remainingAmount: Se,
  report: Fe,
  "reportsError.tooManyDownloads": "Non siamo riusciti a scaricare tutti i file. Riprova più tardi.",
  reportsNotice: De,
  reportsTitle: Oe,
  "reportType.payout": "Pagamento",
  reset: qe,
  Reversed: xe,
  "select.filter.placeholder": "Segnaposto",
  "select.noOptionsFound": "Nessuna opzione corrisponde a questa ricerca",
  somethingWentWrong: Le,
  somethingWentWrongTryRefreshingOrComeBackLater: we,
  status: We,
  structuredList: ke,
  subtractions: Be,
  sumOfSameDayPayouts: Me,
  tabs: Ee,
  theErrorCodeIs: Ve,
  thereAreNoResults: Ue,
  theRequestIsMissingRequiredFieldsOrContainsInvalidData: He,
  thereWasAnUnexpectedError: Ye,
  theSelectedBalanceAccountIsIncorrect: Qe,
  timezone: _e,
  to: Ge,
  "tooltip.ATM": "Denaro prelevato da uno sportello bancomat",
  "tooltip.Capital": "Denaro derivante da una concessione di prestito in entrata o dal rimborso del prestito in uscita",
  "tooltip.Chargeback": "Denaro restituito a un cliente dopo una transazione contestata",
  "tooltip.Correction": "Aggiustamenti ai tuoi fondi, inclusi storni di transazioni e correzioni di depositi",
  "tooltip.Fee": "Costi di transazione e commissioni sui metodi di pagamento",
  "tooltip.Other": "Transazioni non appartenenti a un'altra categoria, di solito un aggiustamento",
  "tooltip.Payment": "Denaro ricevuto sul tuo conto da una transazione di vendita",
  "tooltip.Refund": "Denaro restituito a un cliente da una transazione rimborsata",
  "tooltip.totalIncoming": "Tutto il denaro ricevuto sul conto in base ai filtri selezionati",
  "tooltip.totalOutgoing": "Tutte le commissioni, i rimborsi, i pagamenti e le altre spese in base ai filtri selezionati",
  "tooltip.Transfer": "Denaro trasferito tra il tuo conto e un altro conto",
  totalIncoming: Xe,
  totalOutgoing: je,
  toValueShouldBeGreaterThanTheFromValue: Je,
  transactionDetails: Ke,
  transactions: Ze,
  transactionsOverviewTitle: $e,
  transactionType: eo,
  transfer: oo,
  tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain: io,
  tryRefreshingThePageOrComeBackLater: ao,
  txAmount: to,
  "txType.ATM": "ATM",
  "txType.Capital": "Capital",
  "txType.Chargeback": "Riaccredito",
  "txType.Correction": "Correzione",
  "txType.Fee": "Commissione",
  "txType.Other": "Altro",
  "txType.Payment": "Pagamento",
  "txType.Refund": "Rimborso",
  "txType.Transfer": "Trasferimento",
  type: no,
  value: ro,
  weCouldNotLoadThePayoutsOverview: so,
  weCouldNotLoadTheReportsOverview: co,
  weCouldNotLoadTheTransactionsOverview: lo,
  weCouldNotLoadYourBalanceAccounts: uo,
  weCouldNotLoadYourPayouts: po,
  weCouldNotLoadYourReports: mo,
  weCouldNotLoadYourTransactions: fo
};
export {
  p as Booked,
  ue as Pending,
  xe as Reversed,
  e as account,
  o as accountBalance,
  i as accountDescription,
  a as accountID,
  t as additions,
  n as adjustments,
  r as amount,
  s as and,
  c as apply,
  l as back,
  d as balanceAccount,
  u as balanceAccountId,
  m as capture,
  f as category,
  g as chargeback,
  b as closeIconLabel,
  v as contactSupport,
  h as contactSupportForHelp,
  y as contactSupportForHelpAndShareErrorCode,
  z as copied,
  T as copy,
  R as correction,
  C as currency,
  A as date,
  P as dateRange,
  go as default,
  N as description,
  I as dismiss,
  S as download,
  F as downloading,
  D as email,
  O as entityWasNotFound,
  q as entityWasNotFoundDetail,
  x as fee,
  L as file,
  w as filterBar,
  W as from,
  k as full,
  B as fundsCaptured,
  M as goBack,
  E as grantIssued,
  V as grantRepayment,
  U as hideContent,
  H as id,
  Q as inProgress,
  Y as incompleteField,
  _ as loading,
  G as max,
  X as min,
  j as mobile,
  J as netPayout,
  K as nextPayouts,
  Z as noData,
  $ as noNegativeNumbersAllowed,
  ee as noPayoutsFound,
  oe as noReportsFound,
  ie as noTransactionsFound,
  ae as other,
  te as paginatedNavigation,
  ne as partial,
  re as paymentId,
  se as paymentMethod,
  ce as payoutDetails,
  le as payoutsNotice,
  de as payoutsTitle,
  pe as pleaseComeBackLater,
  me as pleaseReachOutToSupportForAssistance,
  fe as reachOutToSupport,
  ge as referenceID,
  be as refresh,
  ve as refund,
  he as refundAction,
  ye as refundActionErrorSubtitle,
  ze as refundActionErrorTitle,
  Te as refundActionSuccessSubtitle,
  Re as refundActionSuccessTitle,
  Ce as refundAmount,
  Ae as refundNotice,
  Pe as refundPayment,
  Ne as refundReason,
  Ie as refundReference,
  Se as remainingAmount,
  Fe as report,
  De as reportsNotice,
  Oe as reportsTitle,
  qe as reset,
  Le as somethingWentWrong,
  we as somethingWentWrongTryRefreshingOrComeBackLater,
  We as status,
  ke as structuredList,
  Be as subtractions,
  Me as sumOfSameDayPayouts,
  Ee as tabs,
  Ve as theErrorCodeIs,
  He as theRequestIsMissingRequiredFieldsOrContainsInvalidData,
  Qe as theSelectedBalanceAccountIsIncorrect,
  Ue as thereAreNoResults,
  Ye as thereWasAnUnexpectedError,
  _e as timezone,
  Ge as to,
  Je as toValueShouldBeGreaterThanTheFromValue,
  Xe as totalIncoming,
  je as totalOutgoing,
  Ke as transactionDetails,
  eo as transactionType,
  Ze as transactions,
  $e as transactionsOverviewTitle,
  oo as transfer,
  io as tryDifferentSearchOrResetYourFiltersAndWeWillTryAgain,
  ao as tryRefreshingThePageOrComeBackLater,
  to as txAmount,
  no as type,
  ro as value,
  so as weCouldNotLoadThePayoutsOverview,
  co as weCouldNotLoadTheReportsOverview,
  lo as weCouldNotLoadTheTransactionsOverview,
  uo as weCouldNotLoadYourBalanceAccounts,
  po as weCouldNotLoadYourPayouts,
  mo as weCouldNotLoadYourReports,
  fo as weCouldNotLoadYourTransactions
};
